import PropTypes from "prop-types";

import { Paper, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";

import { formatDate, formatMoney } from "@/features/shared";

export const GeneralInformationSection = ({ purchasePayment }) => {
  const totalAllocatedAmount = purchasePayment.purchaseInvoicePayments.reduce(
    (sum, payment) => sum + payment.allocatedAmount,
    0
  );

  const totalDiscount = purchasePayment.purchaseInvoicePayments.reduce(
    (sum, payment) => sum + payment.discount,
    0
  );

  const grandTotal = totalAllocatedAmount - totalDiscount;

  return (
    <Paper sx={{ p: 3, borderRadius: 2 }}>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12 }}>
          <Typography variant="subtitle1">Informasi Umum</Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Dibuat oleh
          </Typography>
          <Typography variant="body1">
            {purchasePayment.creator?.name || "-"}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Tanggal Transaksi
          </Typography>
          <Typography variant="body1">
            {formatDate(purchasePayment.transactionDate)}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Pemasok
          </Typography>
          <Typography variant="body1">
            {purchasePayment.seller?.name || "-"}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Outlet
          </Typography>
          <Typography variant="body1">
            {purchasePayment.buyer?.name || "-"}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Kas & Bank
          </Typography>
          <Typography variant="body1">
            {purchasePayment.cashBankOutletChartOfAccount
              ? `${purchasePayment.cashBankOutletChartOfAccount.code} - ${purchasePayment.cashBankOutletChartOfAccount.name}`
              : "-"}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Total Dibayar
          </Typography>
          <Typography variant="body1">
            {formatMoney(totalAllocatedAmount)}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Total Diskon
          </Typography>
          <Typography variant="body1">
            {formatMoney(totalDiscount)}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Grand Total
          </Typography>
          <Typography variant="body1" sx={{
            fontWeight: "bold"
          }}>
            {formatMoney(grandTotal)}
          </Typography>
        </Grid>
        {purchasePayment.convertedSalesPayment && (
          <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
            <Typography variant="body2" sx={{
              color: "text.secondary"
            }}>
              Penerimaan Penjualan
            </Typography>
            {/* Plain text, not a link: sales payments are seller-scoped and
                this document is buyer-scoped, so the outlet viewing this page
                is by definition not the one that can open the mirror. */}
            <Typography variant="body1">
              {purchasePayment.convertedSalesPayment.referenceNumber}
            </Typography>
          </Grid>
        )}
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Catatan
          </Typography>
          <Typography variant="body1">
            {purchasePayment.note ?? "-"}
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

GeneralInformationSection.propTypes = {
  purchasePayment: PropTypes.object.isRequired,
};
